export const typographyStyles = {
  mainHeading: {
    fontSize: "43.3px",
    fontWeight: "800",
    fontFamily: "var(--inter)",
  },
  subHeading: {
    fontFamily: "var(--inter)",
    fontSize: "25px",
    fontWeight:600,
    // textAlign: "left",

  }
}


export const style = {
  HeadingStyle: {
    fontFamily: "var(--inter)",
    fontSize: "26px",
    fontWeight: 800,
    lineHeight: "33px",
    letterSpacing: "-0.01em",
    textAlign: "left",
  },

  subHeading: {
    fontFamily: "var(--inter)",
    fontSize: "17px",
    fontWeight: 700,
    lineHeight: "20px",
    letterSpacing: "-0.01em",
    textAlign: "left",
  },
};